<template lang="pug">
a-popover(:title="code" :destroyTooltipOnHide="true"  placement="rightBottom")
    a {{code}}
    template(slot="content")
        a-spin.chart(v-if="loading")
        div(v-else style="width: 400px")
            MarketRtChart(:code="code")
        //- v-chart.chart(:option="option" :autoresize="true" v-else)
</template>

<script>
import _ from 'lodash';
import MarketRtChart from './MarketRtChart.vue';
// import Chart from './Chart.vue';

export default {
    props: ['code'],
    data() {
        return {
            loading: false,
            prices: [],
            xlabels: [],
            limitUp: null,
            limitDown: null,
        };
    },
 

    components: {
        MarketRtChart
    },
    mounted() {

    }
}
</script>

<style lang="less" scoped>
.chart {
    height: 250px;
    width: 400px;
    // margin: 5px;
}
</style>